import React from "react";

import { Box, Typography } from "@mui/material";
import Image from "../components/image/Image";
import image from "../resources/images/landing-page/2.jpg";

const Section3 = (props) => {
  const nowMediaQuery = props.nowMediaQuery;

  return (
    <section className="section background-light-blue">
      <div className="contents">
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Box
            width={nowMediaQuery !== "mobile" ? "400px" : "250px"}
            mr={nowMediaQuery !== "mobile" ? 10 : 2}
          >
            <Image disabledEffect src={image} sx={{ borderRadius: 1 }} />
          </Box>
          <Box>
            <Typography variant="h6" my={1}>
              자살률과 고독사가 전국에서 가장 높은 관악구 고시촌 대학동,
            </Typography>
            <Typography variant="h5" mb={1} lineHeight={1.5}>
              해피인은 복지 사각지대에 놓인 이들의
              <strong className="blue"> 회복</strong>을 돕고,
              <br /> 함께 살아가는
              <strong className="blue"> 자립형 공동체</strong>를 만들어갑니다.
            </Typography>
          </Box>
        </Box>
      </div>
    </section>
  );
};

export default Section3;
